/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";
import "./index.css";
import formatDate from "../../util/formatdate";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import { getWorkAnniversaries } from "../../api/services/hroneApi";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const MyLoader = () => (
  <ContentLoader
    className="holidays-list-content-loader"
    backgroundColor="#E0E0E0"
  >
    <rect x="0" y="0" rx="5" ry="5" width="300" height="400" />
  </ContentLoader>
);

const orgDetails = JSON.parse(localStorage.getItem("org"));
// const { primaryColor } = orgDetails;

const WorkAnniversary = () => {
  const [anniversaryList, setAnniversariesList] = useState([]);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [showAnniversariesList, setShowAnniversariesList] = useState(false);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    getAnniversariesList();
  }, []);

  const getAnniversariesList = async () => {
    try {
      setApiStatus(apiStatusConstants.inProgress);
      const response = await getWorkAnniversaries();
      if (response.ok) {
        const data = convertKeysToCamelCase(await response.json());
        const updatedData = data.map((eachAnniversary) => ({
          ...eachAnniversary,
          dateOfAnniversary: formatDate(eachAnniversary.joiningDate),
        }));
        setAnniversariesList(updatedData);
        setApiStatus(apiStatusConstants.success);
      }
    } catch (e) {
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const formattedDate = (anniversaryDate) => {
    const parts = anniversaryDate.split("-");

    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[0], 10);

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const textDay = formattedDay(day, monthNames[month - 1], month);

    return textDay;
  };

  const currentDay = new Date().getDate();
  const currentMonth = new Date().getMonth();

  const formattedDay = (day, monthName, month) => {
    if (currentDay === day && currentMonth + 1 === month) {
      return "Today";
    } else if (currentDay + 1 === day && currentMonth + 1 === month) {
      return "Tomorrow";
    } else {
      return day + getDaySuffix(day) + " " + monthName;
    }
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return "th";
    }
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const showOrHideAnniversaries = () => {
    setShowText(!showText);
    if (anniversaryList.length >= 6) {
      setShowAnniversariesList(!showAnniversariesList);
    } else {
      setShowAnniversariesList(false);
    }
  };

  const renderAnniversariesList = () => (
    <div className="work-anniversary-container">
      <p className="work-anniversary-heading">Work Anniversaries</p>
      {anniversaryList.length > 0 ? (
        <>
          <ul
            style={{ height: showAnniversariesList ? "450px" : "258px" }}
            className="work-anniversaries-list"
          >
            {anniversaryList.map((eachAnniversary, index) => (
              <li key={index} className="work-anniversary-card">
                <p className="name-heading">
                  {formattedDate(eachAnniversary.dateOfAnniversary)} - {eachAnniversary.firstName}{" "}
                  {eachAnniversary.lastName}
                </p>
                <div className="details">
                  <p>
                    {eachAnniversary.designation} - {eachAnniversary.department}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <div
          style={{
            height: "274px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p style={{ textAlign: "center" }}>No anniversaries </p>
        </div>
      )}

      <div
        onClick={showOrHideAnniversaries}
        className="container-bottom-section"
      >
        <p style={orgDetails ? { color: orgDetails.primaryColor } : {}}>
          {showText ? "Show Less" : "See All Anniversaries"}
        </p>
      </div>
    </div>
  );

  const DisplayAnniversariesList = () => {
    switch (apiStatus) {
      case apiStatusConstants.success:
        return renderAnniversariesList();
      case apiStatusConstants.failure:
        return <MyLoader />;
      case apiStatusConstants.inProgress:
        return <MyLoader />;
      default:
        return null;
    }
  };

  return <>{DisplayAnniversariesList()}</>;
};

export default WorkAnniversary;
